import React, { Component } from 'react';
import { func, arrayOf, shape, string } from 'prop-types';

import classNames from 'classnames';
import styles from "./styles.scss";

export default class ToggleButtonGroup  extends Component {
  static propTypes = {
    className: string,
    buttons: arrayOf(shape({
      label: string,
      value: string
    })),
    selectedValue: string,
    onSelectionChange: func
  }

  handleButtonClick = value => event => {
    const { onSelectionChange, selectedValue } = this.props;
    onSelectionChange && selectedValue !== value && onSelectionChange(value);
  }

  render () {
    const { className, buttons, selectedValue } = this.props;
    return (
      <div className={classNames(styles.toggleButtonGroup, className)}>
        {
          buttons.map((entry, index) => {
            const isSelected = (selectedValue === undefined && index === 0) || selectedValue === entry.value;
            return (
              <button 
                key={entry.value} 
                value={entry.value}
                onClick={this.handleButtonClick(entry.value)}
                className={classNames(styles.button, {[styles.selected]: isSelected})}
                data-test={"toggleBtn_" + entry.label}
              >
                {entry.label}
              </button>
            );
          })
        }
      </div>
    );
  }
}
